module.exports = __webpack_public_path__ + "static/media/goat.531a060d.svg";